import { CSSProperties, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import tw from 'twin.macro';

interface DimmedBackgroundProps {
  // display의 제어권이 isShow props를 전달한 컴포넌트에 있음
  isShow: boolean;
  children?: React.ReactNode;
  style?: CSSProperties;

  // display의 제어권이 DimmedBackground 컴포넌트에 있음
  onClick?: () => void;
}

export const DimmedBackground = ({ isShow, children, style, onClick }: DimmedBackgroundProps) => {
  const ref = useRef<Element | null>();
  const [mounted, setMounted] = useState<boolean>(false);

  const enableScroll = () => {
    document.body.style.cssText = '';
    document.body.style.overflow = 'unset';
  };

  const disableScroll = () => {
    document.body.style.overflow = 'hidden';
  };

  useEffect(() => {
    if (isShow) {
      disableScroll();
    } else {
      enableScroll();
    }
    return () => {
      enableScroll();
    };
  }, [isShow]);

  useEffect(() => {
    setMounted(true);
    if (document) {
      const dom = document.getElementById('root-modal');
      ref.current = dom;
    }
  }, []);

  if (ref.current && mounted) {
    return createPortal(
      <Container
        isShow={isShow}
        style={{
          ...style,
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        {children}
      </Container>,
      ref.current,
    );
  }
  return null;
};

const Container = styled.div<{ isShow: boolean }>`
  ${tw`w-full inset-auto fixed top-0 bg-black/40 backdrop-blur-md z-50 transition-opacity duration-75 ease-out`}
  ${tw`md:w-full`}

  display: ${(props) => (props.isShow ? 'flex' : 'none')};

  height: 100%;

  overflow: hidden;
  touch-action: none;

  animation: showModal 0.2s ease-in-out;

  opacity: ${(props) => (props.isShow ? 1 : 0)};

  z-index: ${(props) => props.isShow && 200};

  @keyframes showModal {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
